<template>
    <div class="relative mb-12">
        <div class="flex items-center justify-between stepper">
            <!-- Background line -->
            <div class="absolute top-4 left-6 right-6 h-0.5 bg-gray-200"></div>

            <!-- Progress line -->
            <div class="absolute top-4 left-6 h-0.5 bg-pink-500 transition-all duration-300" :style="{ width: progressWidth }"></div>

            <template v-for="(step, index) in steps" :key="index">
                <div class="relative z-5 flex flex-col items-center">
                    <!-- Circle -->
                    <div class="size-8 flex items-center justify-center rounded-full text-base" :class="circleClass(index + 1)">
                        <!-- Completed -->
                        <i v-if="index + 1 < currentStep" class="icon-check-bold"></i>
                        <!-- Active / upcoming -->
                        <span v-else>{{ index + 1 }}</span>
                    </div>

                    <!-- Label -->
                    <span class="mt-2 text-xs sm:text-sm font-semibold" :class="labelClass(index + 1)">
                        {{ step }}
                    </span>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    currentStep: {
        type: Number,
        required: true
    }
})

const steps = ['Vaša izbira', 'Dodatne možnosti', 'Vaši podatki', 'Zaključek']

const totalSteps = steps.length

const progressWidth = computed(() => {
    if (props.currentStep <= 1) return '0%'

    return `${((props.currentStep - 1) / (totalSteps - 1)) * 100}%`
})

const circleClass = (step) => {
    if (step < props.currentStep) {
        return 'bg-pink-500 text-white'
    }
    if (step === props.currentStep) {
        return 'border-2 border-pink-500 text-pink-600 bg-pink-50'
    }
    return 'border-2 border-gray-200 bg-gray-50 text-gray-500'
}

const labelClass = (step) => {
    if (step <= props.currentStep) return 'text-pink-600'
    return 'text-gray-500'
}
</script>
